import { NavLink } from "react-router-dom";
import { ReceiptText, ShieldCheck, MessagesSquare, Blocks, Settings } from "lucide-react";
import { AriaMark } from "@/components/AriaMark";

const ITEMS = [
  { to: "/communications", label: "communications", icon: MessagesSquare },
  { to: "/expenses", label: "expenses", icon: ReceiptText },
  { to: "/policies", label: "policies", icon: ShieldCheck },
  { to: "/integrations", label: "integrations", icon: Blocks },
  { to: "/settings", label: "settings", icon: Settings },
];

export const MobileNav = () => (
  <nav
    data-testid="mobile-nav"
    className="fixed bottom-4 left-1/2 z-40 flex -translate-x-1/2 items-center gap-0.5 rounded-full border border-[#2a2a2a] bg-[rgba(15,15,15,0.88)] px-2 py-1.5 shadow-[0_12px_40px_-8px_rgba(0,0,0,0.85)] backdrop-blur-xl lg:hidden"
  >
    <button
      onClick={() => window.dispatchEvent(new Event("aria:open"))}
      aria-label="aria"
      data-testid="mobile-nav-aria"
      className="flex h-10 w-10 items-center justify-center rounded-full text-[#8a8a8a] transition-colors hover:text-white"
    >
      <AriaMark size={18} />
    </button>
    {ITEMS.map(({ to, label, icon: Icon }) => (
      <NavLink
        key={to}
        to={to}
        aria-label={label}
        data-testid={`mobile-nav-${label}`}
        className={({ isActive }) =>
          `flex h-10 w-10 items-center justify-center rounded-full transition-colors ${
            isActive ? "bg-[rgba(79,142,247,0.2)] text-white" : "text-[#8a8a8a] hover:text-white"
          }`
        }
      >
        <Icon size={17} />
      </NavLink>
    ))}
  </nav>
);
